import React, { useContext, useState, useMemo, useEffect } from 'react';
import {
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from 'reactstrap';
import BreadCrumb from '../Components/Common/BreadCrumb';
import TableContainer from '../Components/Common/TableContainer';
import DeleteModal from '../Components/Common/DeleteModal';
import { CoinRequestContext } from '../context/CoinRequestContext';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import 'moment/locale/fa';

const CoinRequests = () => {
  document.title = 'درخواست‌های سکه | فات 90';

  const { requests, loading, error, fetchRequests, removeRequest } = useContext(CoinRequestContext);
  const [request, setRequest] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  // دریافت درخواست‌ها در بارگذاری اولیه
  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  // حذف تکی
  const onClickDelete = (req) => {
    setRequest(req);
    setDeleteModal(true);
  };

  const handleDeleteRequest = async () => {
    if (request) {
      try {
        await removeRequest(request.id);
        setDeleteModal(false);
      } catch (err) {
        // خطاها توسط CoinRequestContext مدیریت می‌شن
      }
    }
  };

  // انتخاب چندگانه
  const checkedAll = () => {
    const checkall = document.getElementById('checkBoxAll');
    const ele = document.querySelectorAll('.requestCheckBox');
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll('.requestCheckBox:checked');
    setIsMultiDeleteButton(ele.length > 0);
    setSelectedCheckBoxDelete(ele);
  };

  const deleteMultiple = async () => {
    const checkall = document.getElementById('checkBoxAll');
    try {
      for (const element of selectedCheckBoxDelete) {
        await removeRequest(parseInt(element.value));
      }
      setIsMultiDeleteButton(false);
      checkall.checked = false;
      setDeleteModalMulti(false);
    } catch (err) {
      // خطاها توسط CoinRequestContext مدیریت می‌شن
    }
  };

  // ستون‌های جدول
  const columns = useMemo(
    () => [
      {
        header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            className="form-check-input"
            onClick={() => checkedAll()}
          />
        ),
        cell: (cell) => (
          <input
            type="checkbox"
            className="requestCheckBox form-check-input"
            value={cell.getValue()}
            onChange={() => deleteCheckbox()}
          />
        ),
        id: '#',
        accessorKey: 'id',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'نام و نام خانوادگی',
        accessorKey: 'fullName',
        enableColumnFilter: false,
      },
      {
        header: 'شماره تلفن',
        accessorKey: 'phoneNumber',
        enableColumnFilter: false,
      },
      {
        header: 'پیام',
        accessorKey: 'message',
        enableColumnFilter: false,
        cell: (cell) => (
          <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {cell.getValue()}
          </div>
        ),
      },
      {
        header: 'تاریخ ایجاد',
        accessorKey: 'createdAt',
        enableColumnFilter: false,
        cell: (cell) => moment(cell.getValue()).locale('fa').format('DD MMM YYYY, HH:mm'),
      },
      {
        header: 'عملیات',
        cell: (cell) => (
          <UncontrolledDropdown>
            <DropdownToggle href="#" className="btn btn-soft-secondary btn-sm" tag="button">
              <i className="ri-more-fill" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                href="#"
                onClick={() => {
                  const reqData = cell.row.original;
                  onClickDelete(reqData);
                }}
              >
                <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i> حذف
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        ),
      },
    ],
    []
  );

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteRequest}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={deleteMultiple}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="درخواست‌های سکه" pageTitle="مدیریت" />
        <Row>
          <Col xl={12}>
            <Card>
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col>
                    <h5 className="card-title mb-0">لیست درخواست‌های سکه</h5>
                  </Col>
                  <Col className="text-end">
                    {isMultiDeleteButton && (
                      <button
                        className="btn btn-soft-danger"
                        onClick={() => setDeleteModalMulti(true)}
                      >
                        <i className="ri-delete-bin-2-line"></i> حذف انتخاب‌شده‌ها
                      </button>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="pt-0">
                {loading ? (
                  <div className="py-4 text-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/msoeawqm.json"
                      trigger="loop"
                      colors="primary:#25a0e2,secondary:#00bd9d"
                      style={{ width: '72px', height: '72px' }}
                    ></lord-icon>
                    <h5 className="mt-4">در حال بارگذاری...</h5>
                  </div>
                ) : error ? (
                  <div className="py-4 text-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/msoeawqm.json"
                      trigger="loop"
                      colors="primary:#25a0e2,secondary:#00bd9d"
                      style={{ width: '72px', height: '72px' }}
                    ></lord-icon>
                    <h5 className="mt-4">{error}</h5>
                  </div>
                ) : requests && requests.length > 0 ? (
                  <TableContainer
                    columns={columns}
                    data={requests}
                    isGlobalFilter={true}
                    isAddUserList={false}
                    customPageSize={10}
                    divClass="table-responsive mb-1"
                    tableClass="mb-0 align-middle table-borderless"
                    theadClass="table-light text-muted"
                    SearchPlaceholder="جستجو بر اساس نام یا شماره تلفن..."
                  />
                ) : (
                  <div className="py-4 text-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/msoeawqm.json"
                      trigger="loop"
                      colors="primary:#25a0e2,secondary:#00bd9d"
                      style={{ width: '72px', height: '72px' }}
                    ></lord-icon>
                    <h5 className="mt-4">هیچ درخواستی یافت نشد</h5>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CoinRequests;